import React, { Fragment, PureComponent, memo } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { LinkContainer } from "react-router-bootstrap";
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { fas, faGlobeAmericas, faEnvelope } from "@fortawesome/free-solid-svg-icons";
library.add(fas);

import { ImagenesRutas, SiteRutas } from "../request/RutasConfig";
import { Obtener_Menu_Request } from "../request/MenuRequest";
import { Notificacion } from "../components/Util/Notificacion/Notificacion.js";
import CajaTexto from "../components/UI/cajaTexto/cajaTexto.jsx";
import { establecerUsuarioConectado } from '../store/usuario/actions';


class HomePage extends PureComponent {
    _isMounted = false;

    state = {
        listaMenus: [],
        listaMenusFiltro: [],
        Datos: {
            FiltroMenus: {
                value: "",
                attributes: {
                    readOnly: false,
                    focus: false,
                    hidden: "unset",
                    id: "FiltroMenus",
                },
            },
        },
    };

    componentDidMount = async () => {
        const originalFetch = window.fetch;
        let _this = this;
        window.fetch = function () {
            return originalFetch.apply(this, arguments)
                .then((res) => {
                    if (res.status === 401) {
                        _this.props.establecerUsuarioConectado(false);
                        _this.props.history.push(SiteRutas.Login);
                    }

                    return res;
                })
        }
        this._isMounted = true;

        const response = await Obtener_Menu_Request(this.props.token);
        if (response.Exitoso) {
            const temp = response.Datos;

            const listaMenus = temp.filter(
                (m) => m.Menu_Padre > 0 && m.Menu_Url !== ""
            );

            this._isMounted && this.setState({ listaMenus });
        } else {
            Notificacion.error(response.Mensaje);
        }
    };

    onChangeInput = (e) => {
        const name = e.target.name;
        const value = e.target.value;
        let newAttributes = this.state.Datos[name].attributes;

        const Datos = Object.assign({}, this.state.Datos, {
            [name]: { value: value, attributes: newAttributes },
        });
        this.setState({ Datos });

        const listaMenus = this.state.listaMenus;

        if (listaMenus && listaMenus.length > 0 && value.trim().length > 0) {

            const resultado = listaMenus.filter((m) => m.Menu_Nombre.toLowerCase().indexOf(value.trim().toLowerCase()) !== -1);
            this._isMounted && this.setState({ listaMenusFiltro: resultado });
        } else {
            this._isMounted && this.setState({ listaMenusFiltro: [] });
        }
    };

    componentWillUnmount = () => {
        this._isMounted = false;
    };

    render() {
        const { Datos, listaMenusFiltro } = this.state;
        const appVersion = document.getElementById("appVersion").value;

        const logoVisible = listaMenusFiltro.length === 0 ? 'row visible' : 'row invisible';

        const elementosMenu = listaMenusFiltro.map((menu) => (
            <div className="col-3 mt-3" key={menu.Menu_Id}>
                <LinkContainer
                    key={menu.Menu_Id}
                    to={{
                        pathname: menu.Menu_Url,
                        state: { menuId: menu.Menu_Id },
                    }}
                >
                    <div className="menu-card">
                        <div className="card-body text-center mt-3">
                            <FontAwesomeIcon icon={menu.Menu_Imagen} size="3x" />
                            <br />
                            <h5 className="card-title mt-3">{menu.Menu_Nombre}</h5>
                            <br />
                            <h6 className="card-subtitle mb-2 mt-3 text-muted">
                                Menú para visitar de manera rápida
                            </h6>
                        </div>
                    </div>
                </LinkContainer>
            </div>
        ));

        return (
            <Fragment>
                <div className="body-content">
                    <div className="main-container">
                        <div className="main-content">
                            <div className="">
                                <div className="container-fluid container-fullw bg-white">
                                    <div className="row text-center">
                                        <div className="col-md-3"></div>
                                        <CajaTexto
                                            id={Datos.FiltroMenus.attributes.id}
                                            type="text"
                                            value={Datos.FiltroMenus.value}
                                            attributes={Datos.FiltroMenus.attributes}
                                            onChangeInput={this.onChangeInput}
                                            placeholder={"Filtrar Menús"}
                                            col={6}
                                            inputClass={"text-center"}
                                        />
                                    </div>
                                    <div className="row">{elementosMenu}</div>
                                    <div className={logoVisible}>
                                        <div className="col border text-center">
                                            <div className="inicio">
                                                <img src={ImagenesRutas.Logo_LD} />
                                            </div>
                                        </div>
                                    </div>
                                    <div className={logoVisible}>
                                        <div className="col">
                                            <div className="text-center">
                                                <p>
                                                    {" "}
                                                    Desarrollado por: Logical Data, CR. Versión:{" "}
                                                    {appVersion} | Todos los Derechos Reservados |
                                                    Contáctenos:{" "}
                                                    <FontAwesomeIcon icon={faGlobeAmericas} />{" "}
                                                    <a href="http://www.ld.co.cr/" title="">
                                                        {" "}
                                                        http://www.ld.co.cr/{" "}
                                                    </a>
                                                    | <FontAwesomeIcon icon={faEnvelope} />{" "}
                                                    <a href="mailto:info@ld.co.cr">info@ld.co.cr</a>&nbsp;|&nbsp;
                                                    <i className="clip-phone-4"></i> +(506) 4052-2780
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        token: state.usuario.token,
    };
};

const mapDispatchToProps = {
    establecerUsuarioConectado
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(memo(HomePage)));
